module.exports = __webpack_public_path__ + "static/img/background.ca0b93a8.svg";